import React from 'react';

import DrawerContext from './drawerContext';
import useDrawerProvider from './useDrawerProvider';

interface DrawerProviderProps {
	children: any;
}

const DrawerProvider: React.FC<DrawerProviderProps> = ({ children }) => {
	const { drawerConfig, setDrawerConfig } = useDrawerProvider();

	return <DrawerContext.Provider value={{ drawerConfig, setDrawerConfig }}>{children}</DrawerContext.Provider>;
};

export default DrawerProvider;
